import { Col, Input, Row, Select } from 'antd';
import { inject, observer } from 'mobx-react';
import React, { ChangeEventHandler } from 'react';
import styled from 'styled-components';
import { UserStore } from '../../stores';
import { ConsultaStore } from '../../stores/consultaStore';

const HeaderContainer = styled.div`
    text-align: center;
`;


interface FiltrosUsuariosProps {
    consultaStore?: ConsultaStore;
    userStore?: UserStore;
}

@inject('consultaStore')
@inject('userStore')
@observer
class FiltrosUsuarios extends React.Component<FiltrosUsuariosProps> {
    renderFiltroMunicipio = () => {
        return <Input placeholder="Municipio" onChange={this.setUsuario} />;
    };

    setUsuario: ChangeEventHandler<HTMLInputElement> = async event => {
        const { userStore } = this.props;
        userStore!.filtrosConsultaUsuarios!.municipio = event.target.value;
        await userStore!.getUsuarios();
    };
    renderFiltroRol = () => {
        const { consultaStore } = this.props;
        return (
            <Select style={{ width: '100%' }} placeholder="Todos" onChange={this.changeFiltroRol}>
                <Select.Option key={0}>Todos</Select.Option>
                {consultaStore!.roles.map(r => (
                    <Select.Option key={r.id}>{r.nombre}</Select.Option>
                ))}
            </Select>
        );
    };
    changeFiltroRol= async (value: any) =>{
        const { userStore } = this.props;
        userStore!.filtrosConsultaUsuarios!.idRol = value;
        await userStore!.getUsuarios();
    }

    renderFiltros = () => {
        return (
            <>
                <Col span={6}><strong>Municipio</strong> {this.renderFiltroMunicipio()}</Col>
                <Col span={6}><strong>Rol</strong> {this.renderFiltroRol()}</Col>
            </>
        );
    };
    render() {
        return (
            <>
                <HeaderContainer>
                    <Row>{this.renderFiltros()}</Row>
                    <br />
                </HeaderContainer>
            </>
        );
    }
}
export default FiltrosUsuarios;
